.button {
  font-family: inherit;
  font-weight: var(--ns-weight-regular);
  line-height: var(--ns-line-height-tiny);
  color: var(--ns-color-black);
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: transparent;
  border: var(--ns-border-width-thin) solid transparent;
  padding: var(--ns-space-2) var(--ns-space-2);
  font-size: var(--ns-font-size-4);
  border-radius: var(--ns-border-radius-4);
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.button > *:not(:first-child) {
  margin-left: var(--ns-space-1);
}

.button:active {
  box-shadow: var(--ns-box-shadow-button);
  transition: none;
}

.light {
  color: var(--ns-color-black);
  background-color: var(--ns-color-grey-light);
  border: none;
  border-radius: var(--ns-border-radius-pill);
}

.light:hover {
  background-color: var(--ns-color-grey);
}
